import AddressApi from './address-api';

const EMPTY_STATE_MARKER = "N/A";
interface FieldInfo {
    container: Element,
    field: HTMLSelectElement | HTMLInputElement
}
export class CountryStateZip {
    country: FieldInfo;
    state: FieldInfo;
    zip: FieldInfo;
    stateRequired: boolean;
    zipRequired: boolean;
    constructor(addressForm: HTMLElement) {
        const identifier = addressForm.getAttribute('data-address-form');
        const countryItem = addressForm.querySelector(`[data-country-for="${identifier}"]`);
        const stateItem = addressForm.querySelector(`[data-state-for="${identifier}"]`);
        const zipItem = addressForm.querySelector(`[data-zip-for="${identifier}"]`);

        this.country = {
            container: countryItem,
            field: countryItem.querySelector('select')
        };

        this.state = {
            container: stateItem,
            field: stateItem.querySelector('select')
        };

        if (zipItem) {
            this.zip = {
                container: zipItem,
                field: zipItem.querySelector('input:not([type="hidden"])')
            };
        }

        this.country.field.addEventListener('change', this.setStatesForCountry.bind(this));
        this.stateRequired = (this.state.field as HTMLSelectElement).options.length > 1;
        this.zipRequired = !!this.zip && (!!this.state.field.value || !!this.zip.field.value);
        this.updateRequiredMarkers();

        const existingState = this.state.container.hasAttribute('data-state-id');
        if (existingState) {
            const correctStateId = this.state.container.getAttribute('data-state-id');
            this.setStatesForCountry(() => {
                if (!!correctStateId) {
                    this.state.field.value = correctStateId;
                }
            });
        }
    }

    setStatesForCountry = (callback?: () => any) => {
        const selectedCountryId = parseInt(this.country.field.value);
        this.state.field.disabled = true;
        AddressApi.getStatesForCountry(selectedCountryId).then(states => {
            this.state.field.innerHTML = '';
            if (states.length > 1) {
                this.state.field.disabled = false;
                this.stateRequired = true;
                // Zip is set as required/not required based on whether state list is available (and if zip input exists)
                this.zipRequired = !!this.zip;
                states.forEach(state => {
                    this.appendStateOption(state.id.toString(), state.description);
                })
            }
            else {
                this.stateRequired = false;
                // Zip is set as required/not required based on whether state list is available.
                this.zipRequired = false;
            }
            this.updateRequiredMarkers();
            if (callback) {
                callback();
            }
        });
    }

    updateRequiredMarkers = () => {
        this.updateRequiredField(this.state, this.stateRequired);
        !!this.zip && this.updateRequiredField(this.zip, this.zipRequired);

        if (!this.stateRequired) {
            this.appendStateOption('', EMPTY_STATE_MARKER);
            this.state.field.disabled = true;
        }
        else {
            this.state.field.disabled = false;
        }

    }

    updateRequiredField = (field: FieldInfo, required: boolean) => {
        field.container.setAttribute('data-field-required', `${required}`);
        if (required) {
            field.field.setAttribute('required', 'true');
        }
        else {
            field.field.removeAttribute('required');
        }
    }

    appendStateOption = (value: string, name: string) => {
        const option = document.createElement('option');
        option.value = value.toString();
        option.innerHTML = name;
        this.state.field.appendChild(option);
    }
}

const addressForms = Array.from(document.querySelectorAll('[data-address-form]')) as HTMLElement[];
addressForms.forEach(addressForm => {
    new CountryStateZip(addressForm);
});